/**
 * Utilidades compartidas para el flujo de sesiones en formatos (asistencia / consentimiento / satisfacción).
 */

export const extraerSesionNumero = (sesion) => {
  if (!sesion) return NaN;
  let numero = parseInt(sesion?.valorc || sesion?.valor || sesion?.orden || 0, 10);
  if (numero && !Number.isNaN(numero) && sesion?.valorc !== 'null' && sesion?.valor !== 'null') {
    return numero;
  }
  const nombre = (sesion?.nombre || '').toUpperCase();
  if (nombre.includes('PRIMERA')) return 1;
  if (nombre.includes('SEGUNDA')) return 2;
  if (nombre.includes('TERCERA')) return 3;
  if (nombre.includes('CUARTA')) return 4;
  if (nombre.includes('QUINTA')) return 5;
  if (nombre.includes('SEXTA')) return 6;
  if (nombre.includes('SÉPTIMA')) return 7;
  if (nombre.includes('OCTAVA')) return 8;
  return NaN;
};

/**
 * Indica si una sesión tiene todos los formatos obligatorios según el catálogo de esa sesión.
 * @param {number} num - Número de sesión (1-based)
 * @param {Object} map - formulariosCompletadosPorSesion[sesionNum] -> flags
 * @param {Object|null} sesionObj - Elemento de catálogo de sesión (para saber si aplica consentimiento)
 */
export const sesionTieneFormatosCompletos = (num, map, sesionObj) => {
  if (!num || Number.isNaN(num)) return false;
  const f = map[num] || {};
  if (!f.asistencia || !f.satisfaccion) return false;
  const codigo = String(sesionObj?.codigo || '').toLowerCase();
  if (codigo === 'pri_se_bien') {
    return !!(f.consentimientoGeneral || f.consentimiento_crisis);
  }
  return true;
};

export const sesionPuedeAbrirseEnModoSecuencial = (num, sesionesOrdenadas, formulariosMap) => {
  if (!num || Number.isNaN(num)) return true;
  if (num <= 1) return true;
  const prevObj = sesionesOrdenadas.find((s) => extraerSesionNumero(s) === num - 1) || null;
  return sesionTieneFormatosCompletos(num - 1, formulariosMap, prevObj);
};

/**
 * Gestión / lectura: la sesión tiene al menos un formato con registro cargado en el mapa.
 * @param {object} sesion - ítem del catálogo de sesiones
 * @param {object} formulariosMap - { [numSesion]: { asistencia?: bool, ... } }
 */
export const hasSessionData = (sesion, formulariosMap = {}) => {
  const num = extraerSesionNumero(sesion);
  if (!num || Number.isNaN(num)) return false;
  const f = formulariosMap[num];
  if (!f || typeof f !== 'object') return false;
  return Object.keys(f).some((k) => !!f[k]);
};

export const isSessionEnabledForStudent = (
  num,
  sesionesOrdenadas,
  formulariosMap,
  sesionesBloqueoSecuencial
) => {
  if (!sesionesBloqueoSecuencial) return true;
  return sesionPuedeAbrirseEnModoSecuencial(num, sesionesOrdenadas, formulariosMap);
};

export const isSessionEnabledForAdmin = (sesion, formulariosMap) =>
  hasSessionData(sesion, formulariosMap);
